import React, { Component } from 'react'
import { MDBRow, MDBCol, MDBBtn, MDBIcon, MDBDatatable } from 'mdb-react-ui-kit'
import MDB4Datatable from '../../../../components/content/MDB4Datatable/MDB4Datatable.component'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import CommissionPaymentsService from '../../../../shared/services/CommissionPayments.service'
import EliteAgencyTeamService from '../../../../shared/services/EliteAgencyTeam.service'
import './ReferralPartnersTab.component.scss'

class ReferralPartnersTab extends Component {
  constructor(props) {
    super(props)

    const currentDate = new Date()
    const currentYear = currentDate.getFullYear()
    const currentMonth = currentDate.getMonth() + 1

    this.state = {
      baTeams: [],
      selectedTeamId: null,
      selectedYear: currentYear,
      selectedMonth: currentMonth,
      paymentsData: [],
      loading: false,
      loadingTeams: true,
      uploadingFile: false,
      processingCsv: false,
      uploadedCsvData: null,
      uploadedFilePath: null,
      isInitialLoad: true,
      previewRowCount: 10,
      csvValidationWarnings: [],
      csvProcessingErrors: [],
      pagination: { page: 0, per_page: 10 },
    }

    this.fileInputRef = React.createRef()
  }

  componentDidMount() {
    this.fetchBATeams()
  }

  fetchBATeams = async () => {
    try {
      this.setState({ loadingTeams: true })
      const response = await EliteAgencyTeamService.search()

      // Extract teams array from response - handle different response structures
      let teams = []
      if (Array.isArray(response)) {
        teams = response
      } else if (response?.models && Array.isArray(response.models)) {
        teams = response.models
      } else if (response?.data && Array.isArray(response.data)) {
        teams = response.data
      } else if (response?.payload && Array.isArray(response.payload)) {
        teams = response.payload
      }

      // Find Elite Agency Team (filter for teams with "Elite Agency" in name)
      const eliteTeam = teams.find(team => team.team_name && team.team_name.toLowerCase().includes('elite agency'))
      const defaultTeamId = eliteTeam ? eliteTeam.id : teams.length > 0 ? teams[0].id : null

      this.setState(
        {
          baTeams: teams,
          selectedTeamId: defaultTeamId,
          loadingTeams: false,
        },
        () => {
          // Automatically fetch referral payments for default team
          if (defaultTeamId) {
            this.fetchReferralPayments()
          }
        }
      )
    } catch (error) {
      console.error('Error fetching Elite Agency Teams:', error)
      toast.error('Failed to load Elite Agency Teams')
      this.setState({ loadingTeams: false })
    }
  }

  fetchReferralPayments = async () => {
    const { selectedTeamId, selectedYear, selectedMonth, isInitialLoad } = this.state

    if (!selectedTeamId) {
      toast.warning('Please select a Elite Agency Team')
      return
    }

    try {
      this.setState({ loading: true })
      const response = await CommissionPaymentsService.getReferralPartnerPayments(
        selectedTeamId,
        selectedYear,
        selectedMonth
      )

      this.setState({
        paymentsData: response.data || [],
        loading: false,
        isInitialLoad: false,
      })

      if (!response.data || response.data.length === 0) {
        if (!isInitialLoad) {
          toast.info('No sales with referral partners found for the selected period')
        }
      }
    } catch (error) {
      console.error('Error fetching referral partner payments:', error)
      toast.error('Failed to load referral partner payments')
      this.setState({ loading: false, isInitialLoad: false })
    }
  }

  handleTeamChange = e => {
    this.setState({ selectedTeamId: parseInt(e.target.value) }, () => {
      this.fetchReferralPayments()
    })
  }

  handleYearChange = e => {
    this.setState({ selectedYear: parseInt(e.target.value) }, () => {
      this.fetchReferralPayments()
    })
  }

  handleMonthChange = e => {
    this.setState({ selectedMonth: parseInt(e.target.value) }, () => {
      this.fetchReferralPayments()
    })
  }

  handleDownloadCsv = async () => {
    const { selectedTeamId, selectedYear, selectedMonth } = this.state

    if (!selectedTeamId) {
      toast.warning('Please select a Elite Agency Team')
      return
    }

    try {
      toast.info('Generating CSV file...')
      const response = await CommissionPaymentsService.downloadReferralPartnerPaymentsCsv(
        selectedTeamId,
        selectedYear,
        selectedMonth
      )

      if (response.data && response.data.url) {
        window.open(response.data.url, '_blank')
        toast.success('CSV file generated successfully')
      } else {
        toast.error('Failed to generate CSV file')
      }
    } catch (error) {
      console.error('Error downloading CSV:', error)
      toast.error('Failed to generate CSV file')
    }
  }

  handleUploadCsv = () => {
    if (this.fileInputRef.current) {
      this.fileInputRef.current.click()
    }
  }

  handleFileSelect = async e => {
    const file = e.target.files[0]
    if (!file) return

    if (file.type !== 'text/csv' && !file.name.endsWith('.csv')) {
      toast.error('Please select a valid CSV file')
      return
    }

    try {
      this.setState({
        uploadingFile: true,
        uploadedCsvData: null,
        uploadedFilePath: null,
        csvValidationWarnings: [],
        csvProcessingErrors: [],
      })
      toast.info('Uploading CSV file...')

      const uploadResponse = await CommissionPaymentsService.uploadFile(file)

      let filePath = null
      if (uploadResponse?.payload?.file_path) {
        filePath = uploadResponse.payload.file_path
      } else if (uploadResponse?.file_path) {
        filePath = uploadResponse.file_path
      } else if (uploadResponse?.data?.file_path) {
        filePath = uploadResponse.data.file_path
      } else if (typeof uploadResponse === 'string') {
        filePath = uploadResponse
      }

      if (!filePath) {
        throw new Error('File upload failed - could not extract file path from response')
      }

      toast.success('CSV file uploaded successfully')

      const { data, warnings } = await this.parseCSVFile(file)

      this.setState({
        uploadingFile: false,
        uploadedCsvData: data,
        uploadedFilePath: filePath,
        previewRowCount: 10,
        csvValidationWarnings: warnings,
      })

      if (warnings.length > 0) {
        toast.warning(`CSV uploaded with ${warnings.length} validation warning(s). Please review below.`, {
          autoClose: 8000,
        })
      } else {
        toast.info('Review the payment changes below and click "Submit Payment Changes" to apply them')
      }
    } catch (error) {
      console.error('Error uploading CSV:', error)
      toast.error(`Failed to upload CSV file: ${error.message || error}`)
      this.setState({
        uploadingFile: false,
        uploadedCsvData: null,
        uploadedFilePath: null,
        csvValidationWarnings: [],
      })
    }

    if (this.fileInputRef.current) {
      this.fileInputRef.current.value = ''
    }
  }

  parseCSVLine = line => {
    const result = []
    let current = ''
    let inQuotes = false

    for (let i = 0; i < line.length; i++) {
      const char = line[i]
      const nextChar = line[i + 1]

      if (char === '"') {
        if (inQuotes && nextChar === '"') {
          // Escaped quote (double quote)
          current += '"'
          i++ // Skip next quote
        } else if (inQuotes && nextChar === ',') {
          // End of quoted field
          inQuotes = false
        } else {
          // Toggle quote state
          inQuotes = !inQuotes
        }
      } else if (char === ',' && !inQuotes) {
        // End of field
        result.push(current.trim())
        current = ''
      } else if (char === '\n' || char === '\r') {
        // Handle newlines within quoted fields
        if (inQuotes) {
          current += char
        }
      } else {
        current += char
      }
    }

    // Add last field
    result.push(current.trim())
    return result
  }

  parseCSVFile = async file => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()

      reader.onload = e => {
        try {
          const text = e.target.result
          const lines = text.split('\n').filter(line => line.trim())

          if (lines.length < 2) {
            reject(new Error('CSV file is empty or invalid'))
            return
          }

          const headers = this.parseCSVLine(lines[0])

          if (!headers.includes('AV ID')) {
            reject(new Error('CSV file is missing required "AV ID" column. Please download the template first.'))
            return
          }

          const data = []
          const warnings = []

          for (let i = 1; i < lines.length; i++) {
            const values = this.parseCSVLine(lines[i])
            const row = {}
            headers.forEach((header, index) => {
              row[header] = values[index] || ''
            })

            const avId = row['AV ID']
            if (!avId || avId.trim() === '') {
              warnings.push(`Row ${i + 1}: Missing AV ID`)
              continue
            }

            // Validate amount fields if provided
            const amtTotal = row['Amount Total']
            if (amtTotal && amtTotal.trim() !== '' && (isNaN(parseFloat(amtTotal)) || parseFloat(amtTotal) < 0)) {
              warnings.push(`Row ${i + 1}: Invalid Amount Total "${amtTotal}" for AV ID ${avId}`)
            }

            const amtPaid = row['Amount Paid']
            if (amtPaid && amtPaid.trim() !== '' && (isNaN(parseFloat(amtPaid)) || parseFloat(amtPaid) < 0)) {
              warnings.push(`Row ${i + 1}: Invalid Amount Paid "${amtPaid}" for AV ID ${avId}`)
            }

            // Validate Amount Balance if provided, but note that it will be auto-calculated if not provided
            const amtBalance = row['Amount Balance']
            if (
              amtBalance &&
              amtBalance.trim() !== '' &&
              (isNaN(parseFloat(amtBalance)) || parseFloat(amtBalance) < 0)
            ) {
              warnings.push(
                `Row ${
                  i + 1
                }: Invalid Amount Balance "${amtBalance}" for AV ID ${avId}. Balance will be auto-calculated from Total - Paid.`
              )
            }

            // Validate Notes for special characters that might cause issues
            const notes = row['Notes']
            if (notes && notes.trim() !== '') {
              // Check for potentially problematic characters (but allow most special chars)
              // Just validate that it's a valid string
              if (typeof notes !== 'string') {
                warnings.push(`Row ${i + 1}: Notes field contains invalid data for AV ID ${avId}`)
              }
            }

            // Auto-calculate balance if not provided but total and paid are provided
            if ((!amtBalance || amtBalance.trim() === '') && amtTotal && amtPaid) {
              const total = parseFloat(amtTotal)
              const paid = parseFloat(amtPaid)
              if (!isNaN(total) && !isNaN(paid)) {
                row['Amount Balance'] = (total - paid).toFixed(2)
              }
            }

            data.push(row)
          }

          resolve({ data, warnings })
        } catch (err) {
          reject(err)
        }
      }

      reader.onerror = () => reject(new Error('Failed to read CSV file'))
      reader.readAsText(file)
    })
  }

  handleSubmitPayments = async () => {
    const { uploadedFilePath } = this.state

    if (!uploadedFilePath) {
      toast.error('No CSV file uploaded')
      return
    }

    try {
      this.setState({ processingCsv: true })
      toast.info('Processing payment changes...')

      const processResponse = await CommissionPaymentsService.processReferralPartnerPaymentsCsv(uploadedFilePath)

      if (processResponse.apistatus) {
        toast.success(processResponse.message || 'Referral partner payments updated successfully')
        this.setState({
          uploadedCsvData: null,
          uploadedFilePath: null,
          processingCsv: false,
          previewRowCount: 10,
          csvValidationWarnings: [],
          csvProcessingErrors: [],
        })
        this.fetchReferralPayments()
      } else {
        let errorMessage = processResponse.message || 'Failed to process CSV file'
        let errors = []

        if (processResponse.errors && Array.isArray(processResponse.errors)) {
          errors = processResponse.errors
          const errorPreview = errors.slice(0, 2).join('; ')
          const additionalErrors = errors.length > 2 ? ` (and ${errors.length - 2} more errors)` : ''
          errorMessage = `${errorMessage}: ${errorPreview}${additionalErrors}. See error details below.`
          toast.error(errorMessage, { autoClose: 10000 })
        } else {
          toast.error(errorMessage)
        }

        this.setState({
          processingCsv: false,
          csvProcessingErrors: errors,
        })
      }
    } catch (error) {
      console.error('Error processing CSV:', error)

      let errorMessage = 'Failed to process CSV file'
      let errors = []

      if (error.response && error.response.data) {
        const responseData = error.response.data
        errorMessage = responseData.message || errorMessage

        if (responseData.errors && Array.isArray(responseData.errors)) {
          errors = responseData.errors
          const errorPreview = errors.slice(0, 2).join('; ')
          const additionalErrors = errors.length > 2 ? ` (and ${errors.length - 2} more errors)` : ''
          errorMessage = `${errorMessage}: ${errorPreview}${additionalErrors}. See error details below.`
        }
      } else if (error.message) {
        errorMessage = `${errorMessage}: ${error.message}`
      }

      toast.error(errorMessage, { autoClose: 10000 })
      this.setState({
        processingCsv: false,
        csvProcessingErrors: errors,
      })
    }
  }

  handleCancelUpload = () => {
    this.setState({
      uploadedCsvData: null,
      uploadedFilePath: null,
      previewRowCount: 10,
      csvValidationWarnings: [],
      csvProcessingErrors: [],
    })
    toast.info('CSV upload cancelled')
  }

  handleLoadMorePreview = () => {
    this.setState(prevState => ({
      previewRowCount: prevState.previewRowCount + 20,
    }))
  }

  handleShowAllPreview = () => {
    const { uploadedCsvData } = this.state
    this.setState({
      previewRowCount: uploadedCsvData.length,
    })
  }

  formatCurrency = value => {
    if (value === null || value === undefined || value === '') return '-'
    const num = parseFloat(value)
    if (isNaN(num)) return '-'
    return `$${num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`
  }

  formatDate = dateString => {
    if (!dateString) return '-'
    const date = new Date(dateString)
    return date.toLocaleDateString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
    })
  }

  getTableData = () => {
    const { paymentsData } = this.state

    const columns = [
      {
        label: 'AV ID',
        field: 'av_id',
        sort: 'asc',
        width: 80,
      },
      {
        label: 'Referral Partner',
        field: 'referral_partner',
        sort: 'asc',
        width: 200,
      },
      {
        label: 'Client',
        field: 'client_name',
        sort: 'asc',
        width: 150,
      },
      {
        label: 'Coverage Type',
        field: 'coverage_type',
        sort: 'asc',
        width: 150,
      },
      {
        label: 'Carrier',
        field: 'carrier',
        sort: 'asc',
        width: 150,
      },
      {
        label: 'Effective Date',
        field: 'effective_date',
        sort: 'asc',
        width: 120,
      },
      {
        label: 'CSR Agent',
        field: 'csr_agent',
        sort: 'asc',
        width: 150,
      },
      {
        label: 'Selling Agent',
        field: 'selling_agent',
        sort: 'asc',
        width: 150,
      },
      {
        label: 'Status',
        field: 'status',
        sort: 'asc',
        width: 120,
      },
      {
        label: 'Premium',
        field: 'premium',
        sort: 'asc',
        width: 100,
      },
      {
        label: 'Term Length',
        field: 'term_length',
        sort: 'asc',
        width: 100,
      },
      {
        label: 'App Date',
        field: 'av_date',
        sort: 'asc',
        width: 120,
      },
      {
        label: 'Amount Total',
        field: 'amt_total',
        sort: 'asc',
        width: 120,
      },
      {
        label: 'Paid At',
        field: 'paid_at',
        sort: 'asc',
        width: 120,
      },
      {
        label: 'W9 Year',
        field: 'w9_year',
        sort: 'asc',
        width: 100,
      },
      {
        label: 'W9 Received Date',
        field: 'w9_received_at',
        sort: 'asc',
        width: 140,
      },
      {
        label: 'Amount Paid',
        field: 'amt_paid',
        sort: 'asc',
        width: 120,
      },
    ]

    const rows = paymentsData.map(payment => ({
      av_id: payment.av_id,
      referral_partner: payment.referral_partner || '-',
      client_name: `${payment.av_client_fname || ''} ${payment.av_client_lname || ''}`.trim() || '-',
      coverage_type: payment.av_coverage || '-',
      carrier: payment.av_carrier || '-',
      effective_date: this.formatDate(payment.av_eff_date),
      csr_agent: payment.csr_agent_name || '-',
      selling_agent: payment.selling_agent_name || payment.agent_name || '-',
      status: payment.av_status || '-',
      premium: this.formatCurrency(payment.av_premium),
      term_length: payment.av_term_length || '-',
      av_date: this.formatDate(payment.av_date),
      amt_total:
        payment.amt_total !== null && payment.amt_total !== undefined ? this.formatCurrency(payment.amt_total) : '-',
      paid_at: this.formatDate(payment.paid_at),
      w9_year: payment.w9_year || '-',
      w9_received_at: this.formatDate(payment.w9_received_at),
      amt_paid:
        payment.amt_paid !== null && payment.amt_paid !== undefined ? this.formatCurrency(payment.amt_paid) : '-',
    }))

    return { columns, rows }
  }

  generateYearOptions = () => {
    const currentYear = new Date().getFullYear()
    const years = []
    for (let i = 0; i < 3; i++) {
      years.push(currentYear - i)
    }
    return years
  }

  generateMonthOptions = () => {
    return [
      { value: 1, label: 'January' },
      { value: 2, label: 'February' },
      { value: 3, label: 'March' },
      { value: 4, label: 'April' },
      { value: 5, label: 'May' },
      { value: 6, label: 'June' },
      { value: 7, label: 'July' },
      { value: 8, label: 'August' },
      { value: 9, label: 'September' },
      { value: 10, label: 'October' },
      { value: 11, label: 'November' },
      { value: 12, label: 'December' },
    ]
  }

  render() {
    const {
      baTeams,
      selectedTeamId,
      selectedYear,
      selectedMonth,
      paymentsData,
      loading,
      loadingTeams,
      uploadingFile,
      processingCsv,
      uploadedCsvData,
      uploadedFilePath,
      csvValidationWarnings,
      csvProcessingErrors,
    } = this.state

    const tableData = this.getTableData()

    return (
      <div className='referral-partners-tab'>
        <MDBRow className='mb-4'>
          <MDBCol md='12'>
            <h4 className='section-title'>Referral Partner Payments</h4>
            <p className='section-description'>
              Select a date range to view all sales with referral partners for that month. Download the CSV, add payment
              values for new or existing records, and re-upload to update referral partner payments. Sales without
              payment records will appear with empty payment fields.
            </p>
          </MDBCol>
        </MDBRow>

        <MDBRow className='mb-4'>
          <MDBCol md='3'>
            <label htmlFor='teamSelect' className='filter-label'>
              Elite Agency Team
            </label>
            <select
              id='teamSelect'
              className='browser-default custom-select'
              value={selectedTeamId || ''}
              onChange={this.handleTeamChange}
              disabled={loading || loadingTeams}
            >
              <option value=''>Select a team...</option>
              {baTeams.map(team => (
                <option key={team.id} value={team.id}>
                  {team.team_name}
                </option>
              ))}
            </select>
          </MDBCol>

          <MDBCol md='3'>
            <label htmlFor='yearSelect' className='filter-label'>
              Year
            </label>
            <select
              id='yearSelect'
              className='browser-default custom-select'
              value={selectedYear}
              onChange={this.handleYearChange}
              disabled={loading}
            >
              {this.generateYearOptions().map(year => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </MDBCol>

          <MDBCol md='3'>
            <label htmlFor='monthSelect' className='filter-label'>
              Month
            </label>
            <select
              id='monthSelect'
              className='browser-default custom-select'
              value={selectedMonth}
              onChange={this.handleMonthChange}
              disabled={loading}
            >
              {this.generateMonthOptions().map(month => (
                <option key={month.value} value={month.value}>
                  {month.label}
                </option>
              ))}
            </select>
          </MDBCol>

          <MDBCol md='3' className='d-flex align-items-end'>
            <MDBBtn
              type='button'
              className='btn-refresh'
              color='primary'
              size='sm'
              onClick={this.fetchReferralPayments}
              disabled={loading || !selectedTeamId}
              block
            >
              {loading ? (
                <>
                  <MDBIcon icon='spinner' spin className='mr-1' />
                  Loading...
                </>
              ) : (
                <>
                  <MDBIcon icon='sync' className='mr-1' />
                  Refresh
                </>
              )}
            </MDBBtn>
          </MDBCol>
        </MDBRow>

        <MDBRow className='mb-3'>
          <MDBCol md='12' className='commission-csv-buttons'>
            <MDBBtn
              type='button'
              className='btn-download-csv'
              color='success'
              size='sm'
              onClick={this.handleDownloadCsv}
              disabled={loading || !selectedTeamId || paymentsData.length === 0}
            >
              <MDBIcon icon='download' className='mr-1' />
              Download CSV
            </MDBBtn>
            <MDBBtn
              type='button'
              className='btn-upload-csv'
              color='info'
              size='sm'
              onClick={this.handleUploadCsv}
              disabled={uploadingFile}
            >
              {uploadingFile ? (
                <>
                  <MDBIcon icon='spinner' spin className='mr-1' />
                  Uploading...
                </>
              ) : (
                <>
                  <MDBIcon icon='upload' className='mr-1' />
                  Upload CSV
                </>
              )}
            </MDBBtn>
            <input
              type='file'
              ref={this.fileInputRef}
              style={{ display: 'none' }}
              accept='.csv'
              onChange={this.handleFileSelect}
            />
          </MDBCol>
        </MDBRow>

        {/* CSV Validation Warnings Section */}
        {csvValidationWarnings && csvValidationWarnings.length > 0 && (
          <MDBRow className='mt-4 mb-3'>
            <MDBCol md='12'>
              <div className='alert alert-warning' role='alert'>
                <h6 className='alert-heading'>
                  <MDBIcon icon='exclamation-triangle' className='mr-2' />
                  CSV Validation Warnings ({csvValidationWarnings.length})
                </h6>
                <p className='mb-2'>
                  The following issues were detected in your CSV file. Rows with missing AV IDs have been skipped:
                </p>
                <ul className='mb-0' style={{ maxHeight: '200px', overflowY: 'auto' }}>
                  {csvValidationWarnings.map((warning, index) => (
                    <li key={index}>{warning}</li>
                  ))}
                </ul>
              </div>
            </MDBCol>
          </MDBRow>
        )}

        {/* CSV Processing Errors Section */}
        {csvProcessingErrors && csvProcessingErrors.length > 0 && (
          <MDBRow className='mt-4 mb-3'>
            <MDBCol md='12'>
              <div className='alert alert-danger' role='alert'>
                <h6 className='alert-heading'>
                  <MDBIcon icon='times-circle' className='mr-2' />
                  CSV Processing Errors ({csvProcessingErrors.length})
                </h6>
                <p className='mb-2'>The following errors prevented processing of your CSV file:</p>
                <ul className='mb-0' style={{ maxHeight: '200px', overflowY: 'auto' }}>
                  {csvProcessingErrors.map((error, index) => (
                    <li key={index}>{error}</li>
                  ))}
                </ul>
              </div>
            </MDBCol>
          </MDBRow>
        )}

        {/* CSV Preview Section */}
        {uploadedCsvData && uploadedCsvData.length > 0 && (
          <MDBRow className='mt-4 mb-4'>
            <MDBCol md='12'>
              <div className='csv-preview-section'>
                <div className='csv-preview-header'>
                  <h5>
                    <MDBIcon icon='file-csv' className='mr-2' />
                    CSV Upload Preview ({uploadedCsvData.length} rows)
                  </h5>
                  <div>
                    <MDBBtn
                      type='button'
                      color='danger'
                      size='sm'
                      onClick={this.handleCancelUpload}
                      disabled={processingCsv}
                      className='mr-2'
                    >
                      <MDBIcon icon='times' className='mr-1' />
                      Cancel
                    </MDBBtn>
                    <MDBBtn
                      type='button'
                      color='primary'
                      size='sm'
                      onClick={this.handleSubmitPayments}
                      disabled={processingCsv}
                    >
                      {processingCsv ? (
                        <>
                          <MDBIcon icon='spinner' spin className='mr-1' />
                          Processing...
                        </>
                      ) : (
                        <>
                          <MDBIcon icon='check' className='mr-1' />
                          Submit Payment Changes
                        </>
                      )}
                    </MDBBtn>
                  </div>
                </div>
                <div className='csv-preview-table'>
                  <table className='table table-sm table-striped table-bordered'>
                    <thead>
                      <tr>
                        {Object.keys(uploadedCsvData[0]).map((header, idx) => (
                          <th key={idx}>{header}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {uploadedCsvData.slice(0, this.state.previewRowCount).map((row, rowIdx) => (
                        <tr key={rowIdx}>
                          {Object.values(row).map((cell, cellIdx) => (
                            <td key={cellIdx}>{cell}</td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {uploadedCsvData.length > this.state.previewRowCount && (
                    <div className='text-center mt-3'>
                      <p className='text-muted mb-2'>
                        Showing {this.state.previewRowCount} of {uploadedCsvData.length} rows
                      </p>
                      <MDBBtn
                        type='button'
                        color='info'
                        size='sm'
                        onClick={this.handleLoadMorePreview}
                        className='mr-2'
                      >
                        <MDBIcon icon='plus' className='mr-1' />
                        Load 20 More
                      </MDBBtn>
                      <MDBBtn type='button' color='secondary' size='sm' onClick={this.handleShowAllPreview}>
                        <MDBIcon icon='eye' className='mr-1' />
                        Show All ({uploadedCsvData.length} rows)
                      </MDBBtn>
                    </div>
                  )}
                  {uploadedCsvData.length <= this.state.previewRowCount && uploadedCsvData.length > 10 && (
                    <div className='text-muted text-center mt-2'>Showing all {uploadedCsvData.length} rows</div>
                  )}
                </div>
              </div>
            </MDBCol>
          </MDBRow>
        )}

        <MDBRow>
          <MDBCol md='12'>
            {loadingTeams ? (
              <div className='loading-container'>
                <MDBIcon icon='spinner' spin size='2x' className='mr-2' />
                Loading Elite Agency Teams...
              </div>
            ) : loading ? (
              <div className='loading-container'>
                <MDBIcon icon='spinner' spin size='2x' className='mr-2' />
                Loading payment data...
              </div>
            ) : paymentsData.length === 0 ? (
              <div className='no-data-message'>
                <MDBIcon icon='info-circle' className='mr-2' />
                No sales with referral partners available for the selected period.
              </div>
            ) : (
              <>
                <MDB4Datatable
                  data={tableData}
                  striped
                  bordered
                  hover
                  responsive
                  entries={25}
                  entriesOptions={[10, 25, 50, 100]}
                  paging={paymentsData.length > 10}
                  searching={true}
                  sortable={true}
                  noBottomColumns
                />
              </>
            )}
          </MDBCol>
        </MDBRow>
      </div>
    )
  }
}

export default ReferralPartnersTab
